import React from "react";
import ReactDOM from "react-dom/client";
import App from "./App.tsx";
import "./styles/main.scss";

import PagerMover from "./components/PagerMover.tsx";

// Contextes
import { GameProvider } from "./utils/GameContexte.tsx";
import { QuestionsProvider } from "./utils/QuestionsContexte.tsx";
import { MenuProvider } from "./utils/BurgerMenuContexte.tsx";
import { InTheGameProvider } from "./utils/InTheGameContexte.tsx";
import { AuthProvider } from "./utils/AuthContexte.tsx";

ReactDOM.createRoot(document.getElementById("root")!).render(
  <React.StrictMode>
    <AuthProvider>
      <MenuProvider>
        <InTheGameProvider>
          <GameProvider>
            <QuestionsProvider>
              <PagerMover />
              <App />
            </QuestionsProvider>
          </GameProvider>
        </InTheGameProvider>
      </MenuProvider>
    </AuthProvider>
  </React.StrictMode>
);
